export default "__VITE_ASSET__X3$shwWj__"